define.alias("shared/components/shared/ui/mobile-menu", "preview-grid/components/shared/ui/mobile-menu");